<aslib-title Text="Geração/Arquivo IPM" SubText="Gerar" Icon="fa fa-dollar"></aslib-title>


<form novalidate [formGroup]='formGeracaoIpm'>

  <div class="form-group row">
    <label for="" class="col-md-3 text-right">Ano de Referência do Índice:<span>*</span></label>
    <div class="controls col-md-3">
      <select [(ngModel)]="_anoSelected"  formControlName="Ano" class="form-control"  (change)="validaAno()">
        <option [ngValue]=undefined>Selecione</option>
        <option *ngFor="let ano of listaAno" [ngValue]= "ano">{{ano.Descricao}}</option>
      </select>
    </div>
  </div>

  <div class="form-group row">
    <label for="" class="col-md-3 text-right">Banco:<span>*</span></label>
    <div class="controls col-md-3">
      <select  [(ngModel)]="_bancoSelected" formControlName="Banco" class="form-control" >
        <option [ngValue]=undefined>Selecione</option>
        <option *ngFor="let banco of listaBanco" [ngValue]="banco">{{banco.Descricao}}</option>
      </select>
    </div>
  </div>

  <div class="form-group row">
    <label for="" class="col-md-3 text-right">Tipo de Receita:<span>*</span></label>
    <div class="controls col-md-3">
      <select  [(ngModel)]="_tipoReceitaSelected"  formControlName="TipoReceita" class="form-control" (change)="validaTipo()">
        <option  [ngValue]=undefined>Selecione</option>
        <option *ngFor="let tipoReceita of listaTipoReceita" [ngValue]="tipoReceita">{{tipoReceita.Descricao}}</option>
      </select>
    </div>
  </div>

  <div class="form-group row">
    <label for="" class="col-md-3 text-right">Nº Sequencial:<span>*</span></label>
    <div class="controls col-md-1">
      <input type="number" [(ngModel)]="_sequencialSelected" formControlName="Sequencial" class="form-control">
    </div>
  </div>

  <div class="form-group row">
    <div class="controls col-md-9 offset-md-3">
      <button type="submit" class="btn btn-primary"  [disabled]="disabiliaGeracao" (click)="gerarArquivoIpmtxt()">
        <aslib-icon type="1" icon="fa fa-check"></aslib-icon>Gerar Arquivo
      </button>
    </div>
  </div>


</form>


<div class="form-group row mb-5" *ngIf="exibirGrid" >
  
  <aslib-grid id="as-grid" class="col-md-12" [(dataset)]="controleArquivoReceitaModelView.ListaControleArquivoReceita" [pagination]="true">
    
    <aslib-grid-column [property]="'NomeArquivo'" [header]="'Nome do Arquivo'" [width]="100" [sortable]="true"></aslib-grid-column>

    <aslib-grid-column [property]="'DataGeracao'"  [width]="50" [header]="'Data de Geração'"  [sortable]="true">
      <ng-template #AslibGridCell let-item="item">
        <span>{{ item.DataGeracao | date : 'dd/MM/yyyy'}}</span>
      </ng-template>
    </aslib-grid-column>

    <aslib-grid-column [property]="'SequencialRemessa'"  [width]="50" [header]="'Nº Sequencial'"  [sortable]="true">
      <ng-template #AslibGridCell let-item="item">
        <span>{{ item.SequencialRemessa}}</span>
      </ng-template>
    </aslib-grid-column>

    <aslib-grid-column [property]="'DataTransmissao'"  [width]="50" [header]="'Data de Transmissão'"  [sortable]="true">
      <ng-template #AslibGridCell let-item="item">
        <span>{{ this.validaItem(item.DataTransmissao) | date : 'dd/MM/yyyy HH:mm' }}</span>
        
      </ng-template>
    </aslib-grid-column>

    <aslib-grid-column [property]="'DescricaoTipoReceita'" [width]="50" [header]="'Tipo de Receita'"  [sortable]="true">
      <ng-template #AslibGridCell let-item="item">
      <span>{{ item.DescricaoTipoReceita}}</span>
      </ng-template>
    </aslib-grid-column>

    <aslib-grid-column [property]="'DescricaoSituacaoProcessamento'"  [width]="50" [header]="'Status'"  [sortable]="true">
      <ng-template #AslibGridCell let-item="item">
        <span>{{ item.DescricaoSituacaoProcessamento}}</span>
      </ng-template>
    </aslib-grid-column>

    <aslib-grid-column [property]="'IdSituacaoProcessamento'"  [width]="50" [header]="'Id Status'" [sortable]="true" [visible]="false"> 
      <ng-template #AslibGridCell let-item="item">
        <span>{{  this.validaStatus(item.IdSituacaoProcessamento, item) }}</span>
      </ng-template>
    </aslib-grid-column>
  
    <aslib-grid-column [property]="'active'" [header]="'Ações'" [width]="50" [sortable]="false" [resizable]="false"
        class="text-center">
        <ng-template #AslibGridHeader let-item="item"><span>Ações</span></ng-template>
        <ng-template #AslibGridCell let-item="item">
          <button type="button" class="btn btn-sm btn-primary" 
            [disabled]="disabilitarAceite"
            title= {{titleValueBotaoAceite}}
            ascas-data="Aceitar Arquivo" 
            (click)="statusArquivo(item, 3)">
            <aslib-icon type="1" icon="fa fa-check-square-o"></aslib-icon>
          </button>
          <button type="button" class="btn btn-sm btn-primary" 
            [disabled]="desabilitarRejeite"
            title= {{titleValueBotaoRejeite}}
            ascas-data="Rejeitar Arquivo" 
            (click)="statusArquivo(item, 4)">
            <aslib-icon type="1" icon="fa fa-window-close"></aslib-icon>
          </button>
          <button type="button" class="btn btn-sm btn-primary" 
            [disabled]="desabilitarCancele"
            title= {{titleValueBotaoCancele}}
            ascas-data="Cancelar Arquivo"
            (click)="statusArquivo(item, 5)">
            <aslib-icon type="1" icon="fa fa-minus-square-o"></aslib-icon>
          </button>

        </ng-template>
      </aslib-grid-column>

  </aslib-grid>
</div>

<aslib-modal #modalMensagem></aslib-modal>




// WEBPACK FOOTER //
// ./src/app/ipm/geracao-arquivo-ipm/geracao-arquivo-ipm.component.html